import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import TopicDataTable from './topicDataTable';
import Filter from '../../components/filter';
import Header from '../../components/header';

const Topics: React.FC = () => {
    const [filterValue, setFilterValue] = useState<any>({});

    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen w-1/6 bg-white '} />


            <div className="w-full h-screen w-5/6 bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">Topics</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-400 mb-6">
                        Identification of major topics with sentiment breakdowns and trend visualizations.
                        {/* <span className='text-base font-semibold text-gray-500'>Learn More</span> */}
                    </p>

                    <div className="flex justify-between mb-5 ipad-column">
                        <div className="flex-1 ipad-order-2">
                            {/* Card Component */}
                            <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 h-screen overflow-auto">
                                <TopicDataTable filterValue={filterValue} />
                            </div>
                        </div>

                        <Filter
                            onApplyFilter={handleApplyFilter}
                            onClearFilter={handleClearFilter}
                            filterClass={'w-80 bg-white shadow-lg rounded-2xl p-6 ml-4 top-20 sticky h-[450px] ipad-static ipad-order-1 ipad-width-100 ipad-mb-2 '}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Topics;